import RepositoryTemplate from "@/providers/api/helpers/repositoryTemplate"

export default class Extension extends RepositoryTemplate {
  constructor (repository, template) {
    super(template)
    this.repository = repository || {}
  }
}
